const variants = {
  hoverable: {
    animation: "shadow-normal 0.3s ease-in-out",
    "@keyframes shadow-accent": {
      "0%": { boxShadow: "default" },
      "100%": { boxShadow: "hover" },
    },
    "@keyframes shadow-normal": {
      "0%": { boxShadow: "hover" },
      "100%": { boxShadow: "default" },
    },
    "@media (hover: hover)": {
      "&:hover": {
        animation: "shadow-accent 0.3s ease-in-out",
        boxShadow: "hover",
      },
      "&:focus-within": {
        animation: "shadow-accent 0.3s ease-in-out",
        boxShadow: "hover",
      },
    },
  },
};
export default variants;
